import React from 'react';
import { GitCompare, ArrowRight } from 'lucide-react';

/**
 * Desktop / tablet promo tile — same footprint as a ProductCard, lives inline
 * inside the product grid. Surfaced at index 3 by default and can repeat every
 * 12–16 products on long listings.
 */
export const ComparePromoTile = () => (
  <a
    href="/compare"
    data-testid="compare-promo-tile"
    className="
      group relative block overflow-hidden rounded-lg
      bg-primary text-primary-foreground shadow-card hover:shadow-elevated
      transition-all duration-smooth
    "
  >
    {/* Content */}
    <div className="relative h-full min-h-[360px] flex flex-col justify-end p-6">
      <div className="inline-flex items-center gap-1.5 self-start mb-3 px-2.5 py-1 rounded-full bg-white/15 backdrop-blur-sm text-[10px] font-semibold uppercase tracking-wider">
        <GitCompare className="w-3 h-3" />
        Compare Tool
      </div>

      <h3 className="font-bold text-2xl leading-tight mb-2">
        Not Sure Which One to Choose?
      </h3>
      <p className="text-sm text-white/85 mb-4 leading-relaxed">
        Select products to compare features, specs, and finishes in one view.
      </p>

      <span
        data-testid="compare-promo-tile-cta"
        className="
          inline-flex items-center justify-center gap-2 self-start
          px-4 py-2 rounded-md bg-white text-primary text-sm font-semibold
          group-hover:bg-stone-100 transition-colors
        "
      >
        Compare Products
        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
      </span>
    </div>
  </a>
);

export default ComparePromoTile;
